import { Component, Inject, Renderer2, HostListener, ViewChild } from '@angular/core';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { JobConstant } from 'src/app/constants/label-constants';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonService } from 'src/app/services/common/common.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EncrDecrService } from 'src/app/services/EncrDecr.service';
import { DOCUMENT } from '@angular/common';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { MatSelect } from '@angular/material/select';
import { JobErrorPageMessage } from 'src/app/constants/error-message-constant';

@Component({
  selector: 'app-add-job',
  templateUrl: './add-job.component.html',
  styleUrls: ['./add-job.component.scss'],
})
export class AddJobComponent {
  dropdownList: any[] = [];
  technologyPreferenceList: any[] = [];
  stateList: any[] = [];
  cityList: any[] = [];
  selectedItems: any[] = [];
  jobRoleItems: any[] = [];
  dropdownSettings = {};
  jobConstant: any = [];
  jobId: number = 0;
  commonConstant: any = [];
  JobErrorPageMessage: any = [];
  JobForm: FormGroup = this.formBuilder.group({});
  public Editor = ClassicEditor;
  JobTypeId: any[] = [];
  TechnologyPreferenceId: any = '';
  readonlyPostCode: boolean = false;
  readonlyStreetNo: boolean = false;
  lat: any;
  long: any;
  searchValue: string = '';
  initalValues: any;
  saveStatus: boolean = false;
  formUnchanged = false;
  @ViewChild('singleSelect', { static: true })
  singleSelect!: MatSelect;
  isValidSalary: boolean = true;
  protected _onDestroy = new Subject();
  public FilterCtrl: FormControl = new FormControl();
  public filteredData: ReplaySubject<any> = new ReplaySubject();
  public CityFilterCtrl: FormControl = new FormControl();
  public cityFilteredData: ReplaySubject<any> = new ReplaySubject();
  public technologyFilterCtrl: FormControl = new FormControl();
  public technologyFilteredData: ReplaySubject<any> = new ReplaySubject();
  constructor(
    private CommonService: CommonService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private EncrDecr: EncrDecrService,
    private router: Router,
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) { }

  @HostListener('window:beforeunload', ['$event'])
  public canDeactivate(event: any): any {
    if (event.type == 'beforeunload') {
      if (
        this.CommonService.onFormValueChange(
          this.saveStatus,
          this.initalValues,
          this.JobForm.value
        )
      ) {
        event.preventDefault();
        event.returnValue = false;
      }
    } else {
      return this.CommonService.onFormValueChange(
        this.saveStatus,
        this.initalValues,
        this.JobForm.value
      );
    }
  }
  protected filterstates() {
    if (!this.stateList) {
      return;
    }
    let search = this.FilterCtrl.value;
    if (!search) {
      this.filteredData.next(this.stateList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filteredData.next(
      this.stateList.filter(
        (data) => data.value.toLowerCase().indexOf(search) > -1
      )
    );
  }
  protected filtercity() {
    if (!this.cityList) {
      return;
    }
    let search = this.CityFilterCtrl.value;
    if (!search) {
      this.cityFilteredData.next(this.cityList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    this.cityFilteredData.next(
      this.cityList.filter(
        (data) => data.value.toLowerCase().indexOf(search) > -1
      )
    );
  }
  protected filterTechnologyPreference() {
    if (!this.technologyPreferenceList) {
      return;
    }
    let search = this.technologyFilterCtrl.value;
    if (!search) {
      this.technologyFilteredData.next(this.technologyPreferenceList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.technologyFilteredData.next(
      this.technologyPreferenceList.filter(
        (data) => data.value.toLowerCase().indexOf(search) > -1
      )
    );
  }

  ngOnDestroy() {
    this._onDestroy.next(1);
    this._onDestroy.complete();
  }
  async ngOnInit(): Promise<void> {
    this.jobConstant = JobConstant;
    this.JobErrorPageMessage = JobErrorPageMessage;
    this.onInitCompanyForm();
    await this.getJobTypeList();
    this.getParentTechnologyPreferenceList();
    this.getStateList();
    this.filteredData.next(this.stateList.slice());
    this.FilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterstates();
      });
    this.technologyFilteredData.next(this.technologyPreferenceList.slice());
    this.technologyFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterTechnologyPreference();
      });
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
    this.route.params.subscribe((params) => {
      if (params['id'] !== undefined && params['type'] != 'add') {
        var decrypted = params['id'] ? params['id'] : '';
        this.jobId = Number(this.EncrDecr.get('123456$#@$^@1ERF', decrypted));
        setTimeout(() => {
          this.GetJobDetail(this.jobId);
        }, 1000);

      } else {
        var decrypted = params['id'] ? params['id'] : '';
        this.jobId = Number(this.EncrDecr.get('123456$#@$^@1ERF', decrypted));
      }
    });
    this.initalValues = this.JobForm.value;
  }

  onInitCompanyForm() {
    this.JobForm = this.formBuilder.group({
      jobId: [0],
      title: ['', [Validators.required, Validators.maxLength(40)]],
      JobTypeId: ['', Validators.required],
      Description: ['', [Validators.required]],
      Responsblities: ['', [Validators.required]],
      TechnologyPreferenceId: ['', [Validators.required]],
      MinExperience: [
        '',
        [Validators.required, Validators.max(100), Validators.min(0), Validators.pattern(/^\d+(\.\d{1,1})?$/)],
      ],
      Applicant: ['', [Validators.required, Validators.min(1), Validators.pattern('^[0-9]*$')]],
      CompanyAbout: [''],
      CompanyWebSite: [''],
      CompanyType: [''],
      CompanySize: [''],
      CompanyAddress: [''],
      MinimumSalary: [
        '',
        [
          Validators.required,
          Validators.min(0),
          Validators.max(1000000000),
          Validators.pattern(/^\d+(\.\d{1,2})?$/),
        ],
      ],
      MaximumSalary: [
        '',
        [
          Validators.required,
          Validators.min(0),
          Validators.max(1000000000),
          Validators.pattern(/^\d+(\.\d{1,2})?$/),
        ],
      ],
      StateId: ['', [Validators.required]],
      CityId: ['', [Validators.required]],
    });
    this.JobForm.get('CityId')?.disable();
  }

  async GetJobDetail(jobId: number) {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.job.GetJobDetail.replace(
      '{id}',
      jobId.toString()
    );
    this.CommonService.doGet(apiUrl)
      .pipe()
      .subscribe({
        next: (data) => {
          this.selectedItems = [];
          if (data.data) {
            this.lat = data.data.latitude;
            this.long = data.data.longitude;
            this.getCityByStateId(data.data.stateId);
            if (data.data.jobTypeId) {
              const trimmedJobTypeId = data.data.jobTypeId.trim();
              const selectedIds = trimmedJobTypeId.split(',');
              this.JobTypeId = selectedIds.map((id) =>
                this.dropdownList.find((item) => item.id.toString() === id)
              );
              for (var j = 0; j < this.JobTypeId.length; j++) {
                this.jobRoleItems = this.jobRoleItems.concat({
                  id: this.JobTypeId[j].id,
                  name: this.JobTypeId[j].name,
                });
              }
              for (var i = 0; i < this.jobRoleItems.length; i++) {
                this.selectedItems.push(this.jobRoleItems[i]);
              }
            }
          }
          this.setJobForm(data.data);
        },
        error: (err) => {
          console.log('getJobDetail-Error', err);
        }
      });
  }

  setJobForm(data) {
    this.JobForm.setValue({
      jobId: data.jobId ? data.jobId : 0,
      title: data.title,
      JobTypeId: this.selectedItems,
      Description: data.description,
      Responsblities: data.responsblities,
      TechnologyPreferenceId: data.technologyPreferenceId,
      MinExperience: data.minExperience,
      Applicant: data.applicant,
      CompanyAbout: data.companyAbout ? data.companyAbout : '',
      CompanyWebSite: data.companyWebSite ? data.companyWebSite : '',
      CompanyType: data.companyType ? data.companyType : '',
      CompanySize: data.companySize ? data.companySize : '',
      CompanyAddress: data.companyAddress ? data.companyAddress : '',
      MinimumSalary: data.minimumSalary,
      MaximumSalary: data.maximumSalary,
      StateId: data.stateId ? data.stateId : '',
      CityId: data.cityId ? data.cityId : '',
    });
    this.initalValues = this.JobForm.getRawValue();
  }

  get jobFormControl() {
    return this.JobForm.controls;
  }

  onTagSelectAll(item: any) {
    item.forEach((element, index) => {
      this.selectedItems.push(element);
    });
  }

  onTagSelect(item: any) {
    this.selectedItems.push(item);
  }

  onUnSelectAllQuestionSet() {
    this.selectedItems = [];
  }

  onItemDeSelectQuestionSet(item: any) {
    this.selectedItems.forEach((element, index) => {
      if (element.id == item.id) this.selectedItems.splice(index, 1);
    });
  }

  validSalary() {
    this.isValidSalary = true;
    const minimumSalary = this.JobForm.value.MinimumSalary;
    const maximumSalary = this.JobForm.value.MaximumSalary;
    if (minimumSalary >= maximumSalary) {
      this.isValidSalary = false;
    }
  }

  onSubmit() {
    this.isValidSalary = true;
    if (this.JobForm.value.MinimumSalary >= this.JobForm.value.MaximumSalary) {
      this.isValidSalary = false;
      return false;
    }
    if (!this.JobForm.valid) {
      return false;
    }

    this.saveStatus = true;
    this.selectedItems = this.selectedItems.map((item) => item.id.toString());
    this.spinner.show();
    let obj = {
      jobId: this.JobForm.value.jobId
        ? this.JobForm.value.jobId.toString()
        : '0',
      title: this.JobForm.value.title,
      jobTypeId: this.selectedItems,
      technologyPreferenceId:
        this.JobForm.value.TechnologyPreferenceId.toString(),
      applicant: parseInt(this.JobForm.value.Applicant),
      description: this.JobForm.value.Description,
      minExperience: this.JobForm.value.MinExperience,
      responsblities: this.JobForm.value.Responsblities,
      companyAbout: this.JobForm.value.CompanyAbout,
      companyWebSite: this.JobForm.value.CompanyWebSite,
      companyType: this.JobForm.value.CompanyType,
      companySize: this.JobForm.value.CompanySize,
      companyAddress: this.JobForm.value.CompanyAddress,
      latitude: this.lat,
      longitude: this.long,
      minimumSalary: this.JobForm.value.MinimumSalary,
      maximumSalary: this.JobForm.value.MaximumSalary,
      stateId: this.JobForm.value.StateId,
      cityId: this.JobForm.value.CityId,
    };
    const apiUrl = this.apiUrl.apiUrl.job.SaveJob;
    this.CommonService.doPost(apiUrl, obj)
      .pipe()
      .subscribe({
        next: (data) => {
          if (data.success) {
            this.spinner.hide();
            this.router.navigate(['job']);
            this.toastr.success(data.message);
          } else {
            this.spinner.hide();
            this.toastr.error(data.message);
          }
        },
        error: (er) => {
          console.error(er);
        },
      });
  }

  async getJobTypeList() {
    const apiUrl = this.apiUrl.apiUrl.job.GetJobTypeList;
    this.CommonService.doGet(apiUrl)
      .pipe()
      .subscribe({
        next: (data) => {
          if (data && data.data && data.data.length > 0) {
            this.dropdownList = data.data;
          }
        },
        error: (err) => {
          console.log('getHandlerList-Error', err);
        }
      });
  }

  async getParentTechnologyPreferenceList() {
    const apiUrl = this.apiUrl.apiUrl.job.GetParentTechnologyPreferenceList;
    this.CommonService.doGet(apiUrl)
      .pipe()
      .subscribe({
        next: (data) => {
          if (data && data.data && data.data.length > 0) {
            for (let i = 0; i < data.data.length; i++) {
              this.technologyPreferenceList.push({
                id: data.data[i].id,
                value: data.data[i].name,
              });
            }
            this.filterTechnologyPreference();
          }
        },
        error: (err) => {
          console.log('getHandlerList-Error', err);
        }
      });
  }

  async getStateList() {
    const apiUrl = this.apiUrl.apiUrl.job.GetStateList;
    this.CommonService.doGet(apiUrl)
      .pipe()
      .subscribe({
        next: (data) => {
          if (data && data.data && data.data.length > 0) {
            for (let i = 0; i < data.data.length; i++) {
              this.stateList.push({
                id: data.data[i].stateId,
                value: data.data[i].name,
              });
            }
            this.filterstates();
          }
        },
        error: (err) => {
          console.log('getHandlerList-Error', err);
        }
      });
  }

  getCityByStateId(id: any) {
    const selectedStateId = this.JobForm.get('StateId')?.value;
    this.JobForm.patchValue({
      CityId: ""
    });
    if (selectedStateId?.value !== null) {
      this.JobForm.get('CityId')?.enable();
    } else {
      this.JobForm.get('CityId')?.disable();
    }
    let stateId = id;
    this.cityList = [];
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.job.GetCityByStateId.replace(
      '{stateId}',
      stateId.toString()
    );
    this.CommonService.doGet(apiUrl)
      .pipe()
      .subscribe({
        next: (data) => {
          if (data && data.data && data.data.length > 0) {
            for (let i = 0; i < data.data.length; i++) {
              this.cityList.push({
                id: data.data[i].cityId,
                value: data.data[i].name,
              });
            }
            this.cityFilteredData.next(this.cityList.slice());
            this.CityFilterCtrl.valueChanges
              .pipe(takeUntil(this._onDestroy))
              .subscribe(() => {
                this.filtercity();
              });
            this.filtercity();
          }
          this.spinner.hide();
        },
        error: (err) => {
          console.log('getHandlerList-Error', err);
        }
      });
  }

  onCancel() {
    this.router.navigate(['job']);
  }
}
